var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-editor-form',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('stats',{attrs:{"id":_vm.id}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }